module.exports = __webpack_public_path__ + "img/right-arrow.f3d51e7f.svg";